export interface ZLLanguage {
    code: string;
    displayText: string;
    rtl: boolean;
    momentLocale: string;
    globalWebsiteLangCode: string; //used to match what language or fallback language we should link to the global website using
}

export const languageList : ZLLanguage[] = [
    { code: 'en-US', displayText: 'English', rtl: false, momentLocale: 'en', globalWebsiteLangCode: 'en' }, //en-US first, i18n defaults to en-US
    { code: 'ar-SA', displayText: 'العَرَبِيَّة‎', rtl: true, momentLocale: 'ar-sa', globalWebsiteLangCode: 'ar' },
    { code: 'ca-ES', displayText: 'Català', rtl: false, momentLocale: 'ca', globalWebsiteLangCode: 'ca' },
    { code: 'cs-CZ', displayText: 'čeština', rtl: false, momentLocale: 'cs', globalWebsiteLangCode: 'cs' },
    { code: 'de-DE', displayText: 'Deutsch', rtl: false, momentLocale: 'de', globalWebsiteLangCode: 'de' },
    { code: 'es-ES', displayText: 'Español', rtl: false, momentLocale: 'es', globalWebsiteLangCode: 'es' },
    { code: 'fr-CA', displayText: 'Français Canadien', rtl: false, momentLocale: 'fr-ca', globalWebsiteLangCode: 'fr' },
    { code: 'fr-FR', displayText: 'Français', rtl: false, momentLocale: 'fr', globalWebsiteLangCode: 'fr' },
    { code: 'it-IT', displayText: 'Italiano', rtl: false, momentLocale: 'it', globalWebsiteLangCode: 'it' },
    { code: 'nl-NL', displayText: 'Dutch', rtl: false, momentLocale: 'nl', globalWebsiteLangCode: 'nl' },
    { code: 'pt-PT', displayText: 'Português', rtl: false, momentLocale: 'pt', globalWebsiteLangCode: 'pt' },

    //global website does not support these languages so default to 'en'
    { code: 'ja-JP', displayText: '日本語', rtl: false, momentLocale: 'ja', globalWebsiteLangCode: 'en' },
    { code: 'th-TH', displayText: 'ภาษาไทย', rtl: false, momentLocale: 'th', globalWebsiteLangCode: 'en' },
    { code: 'zh-CN', displayText: '中文简体', rtl: false, momentLocale: 'zh-cn', globalWebsiteLangCode: 'en' },
    { code: 'zh-TW', displayText: '中文繁體', rtl: false, momentLocale: 'zh-tw', globalWebsiteLangCode: 'en' }
];
